<template>
  <b-row>
    <b-col>
      <div class="table-height">
        <b-table
          class="okv-custom-table"
          :fields="tableFields"
          :items="tableItems"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          small
          hover
          striped
          selectable
          no-select-on-click
          no-sort-reset
          ref="insightsTable"
        >
          <template v-slot:head()="data">
            {{ $t(data.label) }}
          </template>

          <template v-slot:cell(isTestedProduct)="{ item }">
            <span v-if="item.isTestedProduct" class="px-2">
              <pit-svg></pit-svg>
            </span>
            <span v-else class="px-2">
              <followed-icon :is-followed="item.isFollowed"></followed-icon>
            </span>
          </template>

          <template v-slot:cell(issuerName)="cell">
            <b-link size="sm" @click="onClickTableRow(cell.item)" class="link-to text-decoration-none">
              <span>{{ cell.item.issuerName }}</span>
            </b-link>
          </template>

          <template v-slot:cell(name)="cell">
            <b-link size="sm" @click="onClickTableRow(cell.item)" class="link-to text-decoration-none">
              <span>{{ cell.item.name }}</span>
            </b-link>
          </template>

          <template v-slot:cell(score)="cell">
            <div class="font-weight-bold">
              <span>{{ showScoringValue(cell.value) }}</span>
            </div>
          </template>

          <template v-slot:cell(market)="{ value }">
            {{ translateMarket(value) }}
          </template>

          <template v-slot:cell(status)="{ item }">
            <span v-if="item.status" class="badge badge-secondary rounded-pill px-3 py-1">
              {{ item.status }}
            </span>
          </template>

          <template v-slot:cell(details)="row">
            <b-button size="sm" @click="row.toggleDetails" variant="link">
              <div class="d-flex">
                {{ $t('common.details') }}
                <div class="ml-1" :class="{ rotated: row.detailsShowing }">
                  <span class="text-left">
                    <font-awesome-icon icon="chevron-circle-down" />
                  </span>
                </div>
              </div>
            </b-button>
          </template>

          <template #row-details="{ item }">
            <b-card class="score-card" v-if="item._showDetails">
              <simple-box>
                <b-row no-gutters>
                  <b-col>
                    <fairmat-product-score
                      :lang="$i18n.locale"
                      :key="item.productId"
                      :value="item.productScore"
                      show-drivers-scores
                      show-action-button-link
                      show-distribution
                      :actionButtonLinkClass="['scoring-show-more-info', 'pt-2']"
                      @send-back-score-data-event="showProductScoreData(...arguments, item)"
                      @send-back-distribution-data-event="showDistributionScoreData(...arguments, item)"
                      @send-back-score-filters-event="showIncompatibleScoreFilters"
                      data-test="fairmat-product-score"
                    ></fairmat-product-score>
                  </b-col>
                </b-row>
              </simple-box>
            </b-card>
          </template>
        </b-table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import FollowedIcon from '../Lib/FollowedIcon'
import PitSvg from '../Lib/PitSvg'
import SimpleBox from '../Lib/SimpleBox'
import { mathRoundPercentage } from '../../utils/formatter'

export default {
  components: {
    FollowedIcon,
    PitSvg,
    SimpleBox,
  },
  props: {
    tableItems: Array,
  },
  data() {
    return {
      tableFields: [
        { key: 'isTestedProduct', label: '', class: 'link' },
        {
          key: 'score',
          label: 'efficiencyTestInsights.tableFields.score',
          class: 'score',
          sortable: true,
        },
        { key: 'issuerName', label: 'efficiencyTestInsights.tableFields.issuer', class: 'issuer', sortable: true },
        { key: 'name', label: 'efficiencyTestInsights.tableFields.name', class: 'name', sortable: true },
        { key: 'isin', label: 'efficiencyTestInsights.tableFields.isin', class: 'isin', sortable: true },
        { key: 'market', label: 'efficiencyTestInsights.tableFields.market', class: 'market', sortable: true },
        { key: 'details', label: '', class: 'details' },
      ],
      // Default the results to score descending; not-scored products (score = null → "N/A") sort to
      // the bottom.
      sortBy: 'score',
      sortDesc: true,
    }
  },
  methods: {
    translateMarket(value) {
      const key = `efficiencyTestDetails.comparisonCriteria.coverage.markets.${value}`
      return this.$te(key) ? this.$t(key) : value
    },
    showScoringValue(score) {
      if (score == null || typeof score === 'string' || isNaN(score)) {
        return this.$t('common.notAvailable')
      }
      return mathRoundPercentage(score)
    },
    onClickTableRow(value) {
      this.$emit('click-table-row', value)
    },
    showDistributionScoreData(value, item) {
      this.$emit('show-distribution-score', value, item)
    },
    showProductScoreData(value, item) {
      this.$emit('show-product-score-data', value, item)
    },
    showIncompatibleScoreFilters(value) {
      this.$emit('show-incompatible-score-filters', value)
    },
  },
}
</script>

<style lang="scss">
.score-card {
  min-height: 100px;
  border: none;
  background: none;
  .bg-white {
    background: none !important;
  }
}

.table-height {
  min-height: 70vh;
}
</style>
